module.exports = __webpack_public_path__ + "images/noPaymentImage.183a2fe1.svg";